import { Link } from "react-router-dom";

const TrademinWelcomeBanner = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

        .banner-root {
          position: relative;
          min-height: 100vh;
          background: #0e0e0c;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 5rem 7vw 12vh;
          overflow: hidden;
          font-family: 'DM Sans', sans-serif;
        }

        .banner-watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: 'DM Serif Display', serif;
          font-size: clamp(6rem, 22vw, 20rem);
          color: rgba(255,255,255,0.025);
          white-space: nowrap;
          pointer-events: none;
          user-select: none;
          letter-spacing: 0.06em;
          line-height: 1;
        }

        .banner-glow {
          position: absolute;
          bottom: -10%;
          left: -5%;
          width: 50vw;
          height: 50vw;
          max-width: 700px;
          max-height: 700px;
          background: radial-gradient(circle, rgba(231,135,48,0.08) 0%, transparent 70%);
          pointer-events: none;
        }

        .banner-rule {
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(231,135,48,0.4), transparent);
        }

        .banner-content {
          position: relative;
          z-index: 1;
          max-width: 900px;
        }

        .banner-eyebrow {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 2.25rem;
        }

        .banner-eyebrow-line {
          width: 32px;
          height: 1px;
          background: #E78730;
        }

        .banner-eyebrow-text {
          font-size: 0.7rem;
          letter-spacing: 0.28em;
          text-transform: uppercase;
          color: #E78730;
          font-weight: 500;
        }

        .banner-h1 {
          font-family: 'DM Serif Display', serif;
          font-size: clamp(3.25rem, 9vw, 8.5rem);
          line-height: 0.93;
          color: #fff;
          margin-bottom: 2.25rem;
          max-width: 14ch;
        }

        .banner-h1 em {
          color: #E78730;
          font-style: italic;
        }

        .banner-sub {
          font-size: clamp(0.9rem, 1.5vw, 1.05rem);
          color: rgba(255,255,255,0.4);
          max-width: 48ch;
          line-height: 1.8;
          font-weight: 300;
          margin-bottom: 3.5rem;
        }

        .banner-actions {
          display: flex;
          align-items: center;
          gap: 1.25rem;
          flex-wrap: wrap;
        }

        .banner-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          background: #E78730;
          color: #fff;
          font-size: 0.72rem;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          padding: 1rem 2.25rem;
          font-family: 'DM Sans', sans-serif;
          transition: opacity 0.2s;
          line-height: 1;
        }
        .banner-btn-primary:hover { opacity: 0.82; }
        .banner-btn-primary svg { transition: transform 0.25s; }
        .banner-btn-primary:hover svg { transform: translateX(3px); }

        .banner-btn-ghost {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          border: 1px solid rgba(255,255,255,0.18);
          color: rgba(255,255,255,0.6);
          font-size: 0.72rem;
          font-weight: 400;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          padding: 1rem 2.25rem;
          font-family: 'DM Sans', sans-serif;
          transition: border-color 0.25s, color 0.25s;
          line-height: 1;
        }
        .banner-btn-ghost:hover { border-color: rgba(255,255,255,0.5); color: #fff; }

        /* Bottom stat bar - desktop default */
        .banner-stats {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          border-top: 1px solid rgba(255,255,255,0.06);
          display: grid;
          grid-template-columns: repeat(3, 1fr); /* desktop: 3 side by side */
          z-index: 1;
        }

        .banner-stat {
          padding: 1.5rem 7vw;
          border-right: 1px solid rgba(255,255,255,0.06);
        }
        .banner-stat:last-child { border-right: none; }

        .banner-stat-num {
          font-family: 'DM Serif Display', serif;
          font-size: 1.75rem;
          color: #fff;
          line-height: 1;
          margin-bottom: 0.3rem;
        }
        .banner-stat-num span { color: #E78730; }

        .banner-stat-label {
          font-size: 0.65rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
          font-weight: 400;
        }

        /* Mobile */
        @media (max-width: 640px) {
          .banner-root {
            padding-top: 5rem; 
            padding-bottom: 4rem;  
            justify-content: flex-start;
          }

          .banner-stats {
            position: relative;   /* remove absolute positioning */
            margin-top: 4rem;
            grid-template-columns: 1fr; /* stack vertically */
          }

          .banner-stat {
            padding: 1.25rem 7vw;
            border-right: none;
            border-bottom: 1px solid rgba(255,255,255,0.06);
          }

          .banner-stat:last-child {
            border-bottom: none;
          }
        }
      `}</style>

      <section className="banner-root">
        <div className="banner-rule" />
        <div className="banner-watermark">TRADEMIN</div>
        <div className="banner-glow" />

        <div className="banner-content">
          <div className="banner-eyebrow">
            <span className="banner-eyebrow-line" />
            <span className="banner-eyebrow-text">
              Electrical &amp; Mechanical · Canterbury, NZ
            </span>
          </div>

          <h1 className="banner-h1">
            Welcome to <em>Trademin</em> Ltd.
          </h1>

          <p className="banner-sub">
            Powering homes, businesses, and industries with trusted electrical
            &amp; mechanical expertise.
          </p>

          <div className="banner-actions">
            <Link to="/request-quote" className="banner-btn-primary">
              Request a Quote
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </Link>
            <Link to="/our-services" className="banner-btn-ghost">
              View Our Services
            </Link>
          </div>
        </div>

        {/* Stat bar */}
        <div className="banner-stats">
          <div className="banner-stat">
            <div className="banner-stat-num">
              2<span>+</span>
            </div>
            <div className="banner-stat-label">Years in Service</div>
          </div>
          <div className="banner-stat">
            <div className="banner-stat-num">
              100<span>%</span>
            </div>
            <div className="banner-stat-label">Client Satisfaction</div>
          </div>
          <div className="banner-stat">
            <div className="banner-stat-num">
              NZ<span>Wide</span>
            </div>
            <div className="banner-stat-label">Coverage</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrademinWelcomeBanner;
